import { render, staticRenderFns } from "./IconUserGroupOutline.vue?vue&type=template&id=27e37458"
import script from "./IconUserGroupOutline.vue?vue&type=script&lang=js"
export * from "./IconUserGroupOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports